<template>
  <div class="content">
    <h1>Key words</h1>
    <TableContent :table-info="userTableInfo" name="keyWords"></TableContent>
  </div>
</template>

<script>
import TableContent from "@/Admin/components/TableContent.vue";
import EditAction from "@/Admin/components/form_actions/EditAction.vue";
import DeleteAction from "@/Admin/components/form_actions/DeleteAction.vue";

export default {
  name: "KeywordListView",
  components: { TableContent },
  data: () => ({
    userTableInfo: {
      headers: [
        {
          title: "id",
          align: "start",
          sortable: false,
          key: "id",
        },
        {
          title: "Name",
          align: "start",
          key: "text",
        },
        {
          title: "Count of specialities assigned",
          align: "start",
          key: "speciality_count",
        },
        {
          title: "Actions",
          align: "start",
          key: "actions",
        },
      ],
      actions: [EditAction, DeleteAction],
      warnings: [
        {
          key: "has_speciality",
          name: "Speciality",
        },
        {
          key: "has_answer",
          name: "Answer",
        },
      ],
    },
  }),
};
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
